"use strict";var o=require("styled-components"),e=require("../../providers/Theme/defaultTheme.js"),r=o.css`
    /* --scaler: 1; */
    --switch-color: var(--switch-color-off);

    display: inline-flex;
    gap: calc(6px * var(--scaler));
    align-items: center;
    cursor: pointer;
    user-select: none;
    outline: none;
    font-family: var(
        --switch-font-family,
        ${e.fonts.secondary.fontFamily}
    );
    font-size: clamp(14px, calc(14px * var(--scaler)), 20px);

    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    &:focus-visible {
        --switch-color-focus-outline-focused: var(--switch-color-focus-outline);
    }
    &.on {
        --switch-color: var(--switch-color-on);
    }
    &[aria-readonly='true'] {
        pointer-events: none;
        --switch-color: var(--switch-color-disabled);
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
